import React, { useMemo, useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Button, FormControl } from '@mui/material';
import { CSVLink } from "react-csv";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { Box, IconButton } from '@mui/material';
import ChequeDetails from "../components/ChequeDetails"
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios"
import StickyTitle from '../components/StickyTitle';
import ChequePrint from '../components/ChequePrint';
import company from "../../assets/company.png"
import { Stack, OutlinedInput, Typography, MenuItem, Select } from '@mui/material';

const ChequesPage = () => {
    const [statusFilter, setStatusFilter] = useState("All");
    const [statusVendorFilter, setStatusVendorFilter] = useState("All");
    const [selectedRowData, setSelectedRowData] = useState(null);
    let rowData = {};
    const [data, setData] = useState([]);
    const [vendordata, setVendorData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [isPrintPopupOpen, setIsPrintPopupOpen] = useState(false);
    const defaultLogoUrl = company;

    const filteredData = useMemo(() => {
        if (statusFilter === "All") {
            return data;
        } else {
            return data.filter(row => row.status === statusFilter);
        }
    }, [data, statusFilter]);

    const filteredVendorData = useMemo(() => {
        if (statusFilter === "All") {
            return vendordata;
        } else {
            return vendordata.filter(row => row.status === statusVendorFilter);
        }
    }, [vendordata, statusVendorFilter]);

    const togglePrintPopup = () => {
        setIsPrintPopupOpen(!isPrintPopupOpen);
    };
    const togglePopup = () => {
        setShowPopup(!showPopup);
    };


    const ApproveVendorCheque = async (selectedRowD) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/vendors/approve_cheque`, {
                id: selectedRowD.id,
                status: selectedRowD.status,
                vendorid: selectedRowD.vendorid,
                chequenumber:selectedRowD.chequenumber,
                amountstatus: selectedRowD.amountstatus,
                paymentdate: selectedRowD.paymentdate,
                notes:selectedRowD.notes
            })
            if (response.status === 200) {
                toast.success("Vendor Cheque cleared!");
                setSelectedRowData(null)
            }
            if (response.status === 201) {
                toast.warning("Cheque already cleared!");
                setSelectedRowData(null)
            }
        } catch (error) {

        }
    }

    const ApproveCheque = async (selectedRowD) => {
        try {
            const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/payments/approve_cheque`, {
                id: selectedRowD.id,
                status: selectedRowD.status,
                clientid: selectedRowD.clientid,
                chequenumber:selectedRowD.chequenumber,
                amountstatus: selectedRowD.amountstatus,
                notes: selectedRowD.notes,
                paymentdate: selectedRowD.paymentdate

            })
            if (response.status === 200) {
                toast.success("Client Cheque cleared!")
                setSelectedRowData(null)
            }
            if (response.status === 201) {
                toast.warning("Cheque already cleared!");
                setSelectedRowData(null)
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const fetchAllCheques = async () => {

            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/payments/all_payments`)
                let responseData = await response.json();
                responseData = responseData.payment
                const cheques = responseData.filter((cheque) => cheque.paymenttype === "Cheque")
                setData(cheques);
            } catch (error) {
                console.error("Error fetching data:", error);
            }

        }
        const fetchAllVendorCheques = async () => {

            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/vendors/all_vendorpayments`)
                let responseData = await response.json();
                responseData = responseData.vendors
                const cheques = responseData.filter((cheque) => cheque.paymenttype === "Cheque")
                setVendorData(cheques);
            } catch (error) {
                console.error("Error fetching data:", error);
            }

        }
        fetchAllVendorCheques();
        fetchAllCheques();
    }, [ApproveCheque,ApproveVendorCheque])


    

    

    const columns = useMemo(
        () => [
            // {
            //     accessorKey: 'clientid',
            //     header: 'Client ID',
            //     size: 100,
            // },
            {
                accessorKey: 'status',
                header: 'Status',
                size: 100,
                Cell: ({ cell }) => (
                    <Box display="flex" alignItems="center" gap="18px">
                        <div
                            className={`py-1 w-full flex justify-center text-white rounded-2xl ${cell.getValue() === "Pending" ? 'bg-red-600' : 'bg-green-600'}`}
                        >
                            {cell.getValue()}
                        </div>
                    </Box>
                ),
            },
            {
                accessorKey: 'clientinvoice',
                header: 'Client/Invoice',
                size: 100,
            },
            {
                accessorKey: 'paymentdate',
                header: 'Payment Date',
                size: 100,
            },
            {
                accessorKey: 'paymenttype',
                header: 'Payment Type',
                size: 100,
            },
            {
                accessorKey: 'type',
                header: 'Type',
                size: 100,
            },
            {
                accessorKey: 'amountstatus',
                header: 'Amount',
                size: 100,
            },
            {
                header: 'Print',
                size: 100,
                Cell: ({ cell }) => (
                    <Box display="flex" alignItems="center" gap="18px">
                        <Button
                            variant="contained"
                            // onClick={() => console.log("Row Data:", cell.row.original)}
                            onClick={() => {
                                togglePrintPopup(cell.row.original);
                                setSelectedRowData(cell.row.original); // Assuming setSelectedRowData is a state updater function
                            }}

                            sx={{ backgroundColor: '#5932EA', borderRadius: '10px', px: '36px', py: '4px', color: 'white', fontSize: '14px' }}
                        >
                            Print
                        </Button>
                    </Box>
                ),
            }
        ],
        [],
    );

    const vendorcolumns = useMemo(
        () => [
            // {
            //     accessorKey: 'clientid',
            //     header: 'Client ID',
            //     size: 100,
            // },
            {
                accessorKey: 'vendorname',
                header: 'Vendor Name',
                size: 100,
            },
            {
                accessorKey: 'paymentdate',
                header: 'Payment Date',
                size: 100,
            },
            {
                accessorKey: 'paymenttype',
                header: 'Payment Type',
                size: 200,
            },
            {
                accessorKey: 'amountstatus',
                header: 'Amount',
                size: 100,
            },
            {
                accessorKey: 'status',
                header: 'Status',
                size: 100,
                Cell: ({ cell }) => (
                    <Box display="flex" alignItems="center" gap="18px">
                        <div
                            className={`py-1 w-full flex justify-center text-white rounded-2xl ${cell.getValue() === "Pending" ? 'bg-red-600' : 'bg-green-600'}`}
                        >
                            {cell.getValue()}
                        </div>
                    </Box>
                ),
            },
            {
                header: 'Print',
                size: 100,
                Cell: ({ cell }) => (
                    <Box display="flex" alignItems="center" gap="18px">
                        <Button
                            variant="contained"
                            // onClick={() => console.log("Row Data:", cell.row.original)}
                            onClick={() => {
                                togglePrintPopup(cell.row.original);
                                setSelectedRowData(cell.row.original); // Assuming setSelectedRowData is a state updater function
                            }}

                            sx={{ backgroundColor: '#5932EA', borderRadius: '10px', px: '36px', py: '4px', color: 'white', fontSize: '14px' }}
                        >
                            Print
                        </Button>
                    </Box>
                ),
            }
        ],
        [],
    );

    return (
        <>
            <StickyTitle title="Cheques" no_button={true} />

            <div className='px-4 lg:px-16 py-4 lg:py-10 flex flex-col gap-4 overflow-x-auto'>
                {isPrintPopupOpen && (
                    <div style={{
                        display: isPrintPopupOpen ? 'block' : 'none',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        padding: '20px',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
                        zIndex: '999',
                        height: '90vh',
                        overflowY: 'auto',
                        width: '800px'
                    }}>

                        <button
                            className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
                            onClick={() => setIsPrintPopupOpen(false)}
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                        <ChequePrint
                            companylogo={defaultLogoUrl}
                            clientName={selectedRowData.clientinvoice}
                            clientID={selectedRowData.clientid}
                            paymentDate={selectedRowData.paymentdate}
                            paymentType={selectedRowData.paymenttype}
                            amount={selectedRowData.amountstatus}
                            status={selectedRowData.status}
                            chequeImage={selectedRowData.chequeimage}
                            chequeNumber={selectedRowData.chequenumber}
                            notes={selectedRowData.notes}
                        />

                    </div>
                )}
                <div className="table-filters flex flex-row items-center justify-between ">
                    <div className='text-2xl ml-5 font-bold font-poppins'>All Client Cheques</div>
                </div>
                <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                <Stack>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '10px',
                            alignItems: 'center',
                            paddingX: '32px',
                            paddingY: '8px',
                            borderTopLeftRadius: '10px',
                            borderTopRightRadius: '10px',
                            backgroundColor: 'white',
                            border: '1px solid #E7E8F2',
                        }}
                    >
                        <Typography variant="h4" sx={{ fontSize: "16px", fontWeight: "600", color: "#00AB9B", mr: '10px' }}>Status</Typography>

                        <div className=' flex gap-3 items-center justify-center'>
                            <FormControl sx={{ width: 150 }}>
                                <Select
                                    sx={{ height: 40, fontSize: '12px' }}
                                    displayEmpty
                                    input={<OutlinedInput />}
                                    value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}
                                    MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                >
                                    <MenuItem
                                        key={"Cleared"}
                                        value={"Cleared"}
                                    >
                                        {"Cleared"}
                                    </MenuItem>
                                    <MenuItem
                                        key={"Pending"}
                                        value={"Pending"}
                                    >
                                        {"Pending"}
                                    </MenuItem>
                                    <MenuItem
                                        key={"All"}
                                        value={"All"}
                                    >
                                        {"All"}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                </Stack>

                {filteredData ? (<div className="w-full">
                    <MaterialReactTable
                        enableRowActions
                        enableRowSelection
                        columns={columns}
                        data={filteredData}
                        renderRowActions={({ row }) => (
                            <Box>
                                <IconButton onClick={() => {
                                    rowData = row.original;
                                    setSelectedRowData(rowData)
                                    togglePopup()
                                }}>
                                    <ReceiptIcon />
                                </IconButton>
                            </Box>
                        )}
                        renderTopToolbarCustomActions={({ table }) => {
                            const handleApprove = () => {
                                const selectedRows = table.getSelectedRowModel().flatRows;
                                if (selectedRows.length === 1) {
                                    const selectedRow = selectedRows[0];
                                    const selectedRowId = selectedRow.original.id;
                                    setSelectedRowData(selectedRow);
                                    ApproveCheque(selectedRow.original)
                                }
                            };
                            return (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <Button
                                        color="success"
                                        // disabled={!table.getIsSomeRowsSelected()}
                                        onClick={handleApprove}
                                        variant="contained"
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                        color="success"
                                        variant="contained"
                                    >
                                        <CSVLink data={data}>Export to CSV</CSVLink>
                                    </Button>
                                </div>
                            );
                        }}
                    />
                </div>) : (null)}

                <div className="table-filters flex flex-row items-center justify-between ">
                    <div className='text-2xl ml-5 font-bold font-poppins'>All Vendor Cheques</div>
                </div>

                <Stack>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: '10px',
                            alignItems: 'center',
                            paddingX: '32px',
                            paddingY: '8px',
                            borderTopLeftRadius: '10px',
                            borderTopRightRadius: '10px',
                            backgroundColor: 'white',
                            border: '1px solid #E7E8F2',
                        }}
                    >
                        <Typography variant="h4" sx={{ fontSize: "16px", fontWeight: "600", color: "#00AB9B", mr: '10px' }}>Status</Typography>

                        <div className=' flex gap-3 items-center justify-center'>
                            <FormControl sx={{ width: 150 }}>
                                <Select
                                    sx={{ height: 40, fontSize: '12px' }}
                                    displayEmpty
                                    input={<OutlinedInput />}
                                    value={statusVendorFilter} onChange={(e) => setStatusVendorFilter(e.target.value)}
                                    MenuProps={{ PaperProps: { style: { maxHeight: 300 } } }}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                >
                                    <MenuItem
                                        key={"Cleared"}
                                        value={"Cleared"}
                                    >
                                        {"Cleared"}
                                    </MenuItem>
                                    <MenuItem
                                        key={"Pending"}
                                        value={"Pending"}
                                    >
                                        {"Pending"}
                                    </MenuItem>
                                    <MenuItem
                                        key={"All"}
                                        value={"All"}
                                    >
                                        {"All"}
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                </Stack>

                {filteredVendorData ? (<div className="w-full">
                    <MaterialReactTable
                        enableRowActions
                        enableRowSelection
                        columns={vendorcolumns}
                        data={filteredVendorData}
                        renderRowActions={({ row }) => (
                            <Box>
                                <IconButton onClick={() => {
                                    rowData = row.original;
                                    setSelectedRowData(rowData)
                                    togglePopup()
                                }}>
                                    <ReceiptIcon />
                                </IconButton>
                            </Box>
                        )}
                        renderTopToolbarCustomActions={({ table }) => {
                            const handleApprove2 = () => {
                                const selectedRows = table.getSelectedRowModel().flatRows;

                                if (selectedRows.length === 1) {
                                    const selectedRow = selectedRows[0];
                                    const selectedRowId = selectedRow.original.id;
                                    setSelectedRowData(selectedRow);
                                    ApproveVendorCheque(selectedRow.original)
                                }
                            };
                            return (
                                <div style={{ display: 'flex', gap: '0.5rem' }}>
                                    <Button
                                        color="success"
                                        // disabled={!table.getIsSomeRowsSelected()}
                                        onClick={handleApprove2}
                                        variant="contained"
                                    >
                                        Approve
                                    </Button>
                                    <Button
                                        color="success"
                                        variant="contained"
                                    >
                                        <CSVLink data={data}>Export to CSV</CSVLink>
                                    </Button>
                                </div>
                            );
                        }}
                    />
                </div>) : (null)}

                {showPopup && (
                    <div className="fixed inset-0 flex items-center justify-center z-50">
                        <div className="absolute inset-0 bg-gray-900 opacity-50"></div>
                        <div className="z-50 bg-white p-6 rounded-md shadow-lg flex flex-col">
                            <div className="flex justify-end">
                                <button
                                    className="text-gray-500 hover:text-gray-700"
                                    onClick={togglePopup}
                                >
                                    <svg
                                        className="w-6 h-6"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <ChequeDetails image={selectedRowData.chequeimage} />
                        </div>
                    </div>
                )}
            </div>


        </>
    );
};

export default ChequesPage;